import Constants from "../config/Contants";
import {DeviceType} from "../domain/DeviceType.model";

export default class DeviceTypeUtils {
    static getDeviceType(): DeviceType {
        const width = window.innerWidth;
        let deviceType = DeviceType.DESKTOP_OR_LAPTOP;
        if (width <= Constants.MEDIA_QUERY.MAX_PHONE_WIDTH) {
            deviceType = DeviceType.PHONE;
        } else if (width <= Constants.MEDIA_QUERY.MAX_TABLET_PORTRAIT_WIDTH) {
            deviceType = DeviceType.TABLET_PORTRAIT;
        } else if (width <= Constants.MEDIA_QUERY.MAX_TABLET_LANDSCAPE_WIDTH) {
            deviceType = DeviceType.TABLET_LANDSCAPE;
        }
        return deviceType;
    }
}